import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Role } from '../models/role';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  findSpecificClientState(userId: string): Observable<any> {
    return this.httpClient.post('/rl/api/price/client-state', { userId });
  }

  getUserRole(): string {
    const user: any = JSON.parse(localStorage.getItem('currentUser'));
    if (!user || !user.role) {
      return null;
    }
    return user.role;
  }

  isSuperUser() {
    return this.getUserRole() === Role.RL_SUPER_USER;
  }

  getUser(): User {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  changePassword(changePasswordParams: any): Observable<void> {
    return this.httpClient.post<void>(
      '/rl/api/user-management/change-user-password',
      changePasswordParams,
    );
  }
}
